import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0f45b6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popupbox" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popupbox-title" }, "人员选择", -1))
const _hoisted_3 = { class: "filterbox" }
const _hoisted_4 = { class: "personlist" }
const _hoisted_5 = { class: "refreshbox" }
const _hoisted_6 = { class: "personinfo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "surnbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    position: "bottom",
    show: _ctx.show,
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.show) = $event)),
    round: "",
    closeable: "",
    style: { height: '95%' },
    onOpen: _ctx.fPopupOpen
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_search, {
            modelValue: _ctx.personName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.personName) = $event)),
            modelModifiers: { trim: true },
            placeholder: "请输入名字",
            clearable: "",
            onSearch: _ctx.onSearch
          }, null, 8, ["modelValue", "onSearch"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_pull_refresh, {
              modelValue: _ctx.refreshing,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.refreshing) = $event)),
              onRefresh: _ctx.onRefresh
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_list, {
                  loading: _ctx.loading,
                  "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading) = $event)),
                  finished: _ctx.finished,
                  "finished-text": "没有更多了",
                  onLoad: _ctx.onLoad
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "personlist-item",
                        key: index
                      }, [
                        _createVNode(_component_van_checkbox, {
                          modelValue: item.isSelect,
                          "onUpdate:modelValue": ($event: any) => ((item.isSelect) = $event),
                          onClick: () => _ctx.fCheckboxSelect(item)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("img", {
                            class: "avtor",
                            src: item.photoUrl
                          }, null, 8, _hoisted_7),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["loading", "finished", "onLoad"])
              ]),
              _: 1
            }, 8, ["modelValue", "onRefresh"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass(["submit-btn surn-btn", { active: this.changePersonId }]),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fSureBtn && _ctx.fSureBtn(...args)))
          }, " 确定 ", 2)
        ])
      ])
    ]),
    _: 1
  }, 8, ["show", "onOpen"]))
}